import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import { Link, Redirect } from 'react-router-dom';
import Card from './card';
import Modal from 'react-modal';
import ApiService from './services/apiservice';
import LoadingSkeleton from './LoadingSkeleton';
import { useHistory } from 'react-router-dom';

const cardsData = [
  { id: 4, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/4.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 4.jpg', backVideoUrl: 'https://www.youtube.com/embed/7Honj0h72QM?si=P8Z5DLKplUHG0OI5' },
  { id: 5, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/5.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 5.jpg', backVideoUrl: 'https://www.youtube.com/embed/EMwD-CX9O0E?si=1O1CzIV-FZg9qYJN' },
  { id: 6, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/6.png', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 6.jpg', backVideoUrl: 'https://www.youtube.com/embed/kPWO8vSVAYw?si=1LXUppT0VKbG2XDi' },
  { id: 7, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/7.png', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 7.jpg', backVideoUrl: 'https://www.youtube.com/embed/NRXLVFvyzcQ?si=LYhrpFru9McVc7o_' },
  { id: 8, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/8.png', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 8.jpg', backVideoUrl: 'https://www.youtube.com/embed/YnpQCw2lIXU?si=jGQITwx6xrQYC9o3' },
  { id: 9, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/9.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 9.jpg', backVideoUrl: 'https://www.youtube.com/embed/gfgICQ63XCk?si=UjoQwjFFNQPcd7u-' },
  { id: 10, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/10.png', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 10.jpg', backVideoUrl: 'https://www.youtube.com/embed/DyQ3FCa-6Sk?si=xsCS_qxtgZboDkqk' },
  { id: 11, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/11.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 11.jpg', backVideoUrl: 'https://www.youtube.com/embed/kKgLH6i5FrE?si=iSXb3GQOfnTJyDO3' },
  { id: 12, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/12.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 12.jpg', backVideoUrl: 'https://www.youtube.com/embed/GaCBpN_Q39U?si=-PHdS4hJYsptXR37' },
  { id: 13, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/13.png', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 13.jpg', backVideoUrl: 'https://www.youtube.com/embed/evEAxb4lRhk?si=JzQE6_dkvahKkzNT' },
  { id: 14, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/14.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 14.jpg', backVideoUrl: 'https://www.youtube.com/embed/M1ZTzzBTKW0?si=OMwObV2SSgGzKBSM' },
  { id: 15, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/15.png', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 15.jpg', backVideoUrl: 'https://www.youtube.com/embed/YxVGndf2IF4?si=mp8xqPHw7J-VdBcd' },
  { id: 16, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/16.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 16.jpg', backVideoUrl: 'https://www.youtube.com/embed/V1FCCC8voO0?si=lRBAN7nw868Af6nQ' },
  { id: 17, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/17.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 17.jpg', backVideoUrl: 'https://www.youtube.com/embed/-CQ7XwAVz08?si=otx1W5BXdAxrRrve' },
  { id: 18, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/18.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 18.jpg', backVideoUrl: 'https://www.youtube.com/embed/3Io_JuAJVZs?si=6X9aQbvNaH_06_-9' },
  { id: 19, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/19.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 19.jpg', backVideoUrl: 'https://www.youtube.com/embed/FuBAdlHwzus?si=kWmp98FopaZfALZk' },
  { id: 20, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/20.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 20.jpg', backVideoUrl: 'https://www.youtube.com/embed/P5PC5AIAlAY?si=HbLZylEI4Njv6sDz' },
  { id: 21, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/21.png', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 21.jpg', backVideoUrl: 'https://www.youtube.com/embed/cLqVWo6qsK0?si=OSsX8b_DNdMgO4LI' },
  { id: 22, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/22.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 22.jpg', backVideoUrl: 'https://www.youtube.com/embed/chMW5gsRz2I?si=vZ5oBHKE1ygks9eB' },
  { id: 23, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/23.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 23.jpg', backVideoUrl: 'https://www.youtube.com/embed/FVF-gg9uCOk?si=wCMfBX0ZSgfXp6JK' },
  { id: 24, frontImage: './Cuadros Calendario de Adviento SM Navidad 2023/24.jpg', backImage: './PROMOS ADVIENTO ES/Promociones Adviento ES 24.jpg', backVideoUrl: 'https://www.youtube.com/embed/Dgy5_XvWiSo?si=borUNSkgZweGkxiX' }
];

const Advientos = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [generatedCode, setGeneratedCode] = useState('');
  const apiService = new ApiService();
  const [error, setError] = useState(null);
  const today = new Date().getDate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const sessionData = localStorage.getItem('session');
      const session = JSON.parse(sessionData);

      if (session && session.idUsuario) {
        const response = await apiService.generarCupon(session.idUsuario, session.country);
        setGeneratedCode(response.cupon);
      } else {
        setError('ID de usuario no encontrado en el localStorage');
        localStorage.removeItem('session');
        window.location.href = '#/home';
      }
    } catch (error) {
      setError('Cupon no generado');
    }
  };

  const handleButtonClick = (backImage) => {
    setSelectedCard({ backImage });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
    setGeneratedCode('');
  };

  const getCardStyle = (cardId) => {
    switch (cardId) {
      case 4:
        return { width: '12rem', marginTop: '0px'};
      case 5:
        return { width: '12rem', marginTop: '2px'};
      case 6:
        return { width: '12rem', marginTop: '2px' };
      case 7:
        return { width: '14rem', marginTop: '4px' };
      case 8:
        return { width: '12rem', marginTop: '2px'};
      case 9:
        return { width: '12rem', marginTop: '2px'};
      case 10:
        return { width: '12rem', marginTop: '2px' };
      case 11:
        return { width: '12rem', marginTop: '2px'};
      case 12:
        return { width: '12rem', marginTop: '0px'};
      case 13:
        return { width: '14rem', marginTop: '0px'};
      case 14:
        return { width: '12rem', marginTop: '0px'};
      case 15:
        return { width: '14rem', marginTop: '0px'};
      case 16:
        return { width: '12rem', marginTop: '0px' };
      case 17:
        return { width: '14rem', marginTop: '20px' };
      case 18:
        return { width: '12rem', marginTop: '0px'};
      case 19:
        return { width: '12rem', marginTop: '20px' };
      case 20:
        return { width: '16rem', marginTop: '0px'};
      case 21:
        return { width: '14rem', marginTop: '2px' };
      case 22:
        return { width: '14rem', marginTop: '0px'};
      case 23:
        return { width: '12rem', marginTop: '0px'};
      case 24:
        return { width: '12rem', marginTop: '0px'};
      default:
    }
  };

  const cardContainerStyles = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const history = useHistory();

  useEffect(() => {
    const storedSession = JSON.parse(localStorage.getItem('session'));

    if (!storedSession || new Date().getTime() > storedSession.expirationTime) {
      localStorage.removeItem('session');
      history.push('/home'); 
    }
  }, [history]);

  return (
    <>
      <Redirect to="/home" />;
      <Link to="/home">
        <div className="flex flex-col justify-center items-center" data-aos="fade-right" data-aos-duration="1500">
          <img src={logo} alt="logo" className="img-log" />
        </div>
      </Link>
      <div className="mt-8 card-container" style={cardContainerStyles}>
        {isLoading ? (
          <LoadingSkeleton />
        ) : (

          cardsData.map((card) => (
            <Card
              key={card.id}
              frontImage={card.frontImage}
              backVideoUrl={card.backVideoUrl}
              buttonText="Ver sorpresa"
              onButtonClick={() => handleButtonClick(card.backImage)}
              isDisabled={card.id !== today}
              style={getCardStyle(card.id)}
              handleSubmit={handleSubmit}
              isLoading={isLoading}
            />
          ))
        )}
      </div>
      {!isLoading && selectedCard && (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="Front Image Modal"
          className="modal-content centered-modal bg-opacity-75"
        >
          <button className="close-button" onClick={closeModal}>X</button>
          <div className="modal-content-wrapper">
            <div className="image-container">
              <img src={selectedCard.backImage} alt="Back" />
            </div>
            <div className="code-container">
              <p className='text-white text-2xl font-bold mt-3'>Código generado: {generatedCode}</p>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Advientos;